<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5">
  <div class="my-3 d-flex justify-content-between">
    <div class="font20">
      <span class="font20 click my-5 text-black" routerLink="/staff">
        <i class="fa fa-arrow-left mr-3"></i> Staff Detail
      </span>
    </div>
    <!-- <div class="font20" *rbacAllow="[false]">
      Hi, {{ staff?.user?.fullName }}
    </div> -->

    <div class="d-flex">
      <button
        [hidden]="mentorId == staff.user.id"
        class="btn btn-outline-secondary btn-sm mr-4"
        data-toggle="modal"
        data-target="#sendMessageModal"
      >
        Send Message
      </button>
      <!-- <button
        class="btn btn-secondary btn-sm"
        data-toggle="modal"
        data-target="#AssignCourseModal"
      >
        Assign Courses
      </button> -->
    </div>
  </div>

  <div class="row">
    <div class="col-lg-3 col-sm-12">
      <div class="bg-green border-radius">
        <div class="pb-3 pt-4 text-center profile">
          <div class="profile-img mx-auto">
            <img
              src="{{
                staff?.user?.avatarUrl
                  ? staff?.user?.avatarUrl
                  : 'assets/images/avatar.jpg'
              }}"
              alt=""
              class="w-100"
              style="height: 155px"
            />
          </div>
          <p class="mt-2 font24 font-bold text-white mb-1">
            {{ staff?.user.fullName | titlecase }}
          </p>
          <p class="mt-2 font16 text-white mb-1">
            {{ staff?.user.username }}
          </p>
        </div>

        <div
          class="px-5 py-3 font-bold font12 text-white click d-flex justify-content-between"
          style="
            background: rgba(255, 255, 255, 0.1);
            border-radius: 0px 0px 6px 6px;
          "
        >
          <span data-toggle="modal" data-target="#editModal" #edit>EDIT</span>
          <span
            data-toggle="modal"
            data-target="#deactivateModal"
            *rbacAllow="[true]"
            >{{ active ? 'DEACTIVATE' : 'ACTIVATE' }}</span
          >
        </div>
      </div>
    </div>

    <div class="col-lg-9 col-sm-12 sm-mt bg-white">
      <div class="nav-card bg-white px-4 py-3">
        <ul class="nav nav-pills" id="pills-tab" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              id="pills-Overview-tab"
              data-toggle="pill"
              href="#pills-Overview"
              role="tab"
              aria-controls="pills-Overview"
              aria-selected="true"
              >Overview</a
            >
          </li>
          <li class="nav-item" *rbacAllow="[true]">
            <a
              class="nav-link"
              id="pills-Courses-tab"
              data-toggle="pill"
              href="#pills-Courses"
              role="tab"
              aria-controls="pills-Courses"
              aria-selected="false"
              >Assigned Courses</a
            >
          </li>
          <li class="nav-item" *rbacAllow="[true]">
            <a
              class="nav-link"
              id="pills-LearningPath-tab"
              data-toggle="pill"
              href="#pills-LearningPath"
              role="tab"
              aria-controls="pills-LearningPath"
              aria-selected="false"
              >Assigned Learning Paths</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="pills-ResultsCertificates-tab"
              data-toggle="pill"
              href="#pills-ResultsCertificates"
              role="tab"
              aria-controls="pills-ResultsCertificates"
              aria-selected="false"
              >Results & Certificates</a
            >
          </li>
        </ul>
      </div>
      <hr class="my-0" />

      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-Overview"
          role="tabpanel"
          aria-labelledby="pills-Overview-tab"
        >
          <div class="bg-white py-5 px-4">
            <div class="row">
              <div class="col-lg-8 col-sm-12">
                <div class="row">
                  <div class="col-lg-6 col-sm-12 sm-mt">
                    <div class="my-4">
                      <p class="mb-0 text-grey">ROLE</p>
                      <p class="mb-0 font16">{{ staff?.designation?.name }}</p>
                    </div>
                    <div class="my-4">
                      <p class="mb-0 text-grey">EMAIL</p>
                      <p class="mb-0 font16">{{ staff?.user.username }}</p>
                    </div>
                    <div class="my-4">
                      <p class="mb-0 text-grey">DEPARTMENT</p>
                      <p class="mb-0 font16">{{ staff?.department?.name }}</p>
                    </div>
                    <div class="my-4">
                      <p class="mb-0 text-grey">UNIT</p>
                      <p class="mb-0 font16">{{ staff?.unit?.name }}</p>
                    </div>
                    <div class="my-4">
                      <p class="mb-0 text-grey">DATE ADDED</p>
                      <p class="mb-0 font16">{{ staff?.createdAt | date }}</p>
                    </div>
                  </div>

                  <div class="col-lg-6 col-sm-12 sm-mt">
                    <div class="my-4">
                      <p class="mb-0 text-grey">EMPLOYMENT NO</p>
                      <p class="mb-0 font16">
                        {{ staff?.employmentNumber }}
                      </p>
                    </div>
                    <div class="my-4">
                      <p class="mb-0 text-grey">PHONE NUMBER</p>
                      <p class="mb-0 font16">{{ staff?.user.phoneNumber }}</p>
                    </div>
                    <div class="my-4">
                      <p class="mb-0 text-grey">DIVISION</p>
                      <p class="mb-0 font16">
                        {{ staff?.division?.name }}
                      </p>
                    </div>

                    <div class="my-4">
                      <p class="mb-0 text-grey">ONGOING COURSES</p>
                      <p class="mb-0 font16">
                        {{ staff?.numberOfEnrolledCourses }}
                      </p>
                    </div>
                    <div class="my-4">
                      <p class="mb-0 text-grey">COURSES ASSIGNED</p>
                      <p class="mb-0 font16">{{ courses?.length }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 my-auto sm-mt" *rbacAllow="[true]">
                <p
                  class="mb-0 font16 px-2 staffStatusActive status d-flex align-items-center justify-content-center"
                  *ngIf="active"
                >
                  ACTIVE
                </p>
                <p
                  class="mb-0 font16 px-2 staffStatusInactive status d-flex align-items-center justify-content-center"
                  *ngIf="!active"
                >
                  DEACTIVATED
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade"
          id="pills-Courses"
          role="tabpanel"
          aria-labelledby="pills-Courses-tab"
        >
          <div class="my-5 px-4">
            <div
              *ngIf="courses.length == 0"
              class="text-center emptyLearning py-5 mt-5"
            >
              <div class="font20 d-flex align-items-center m-auto">
                <img src="assets/icons/info.png" alt="" />
                <div class="ml-3 font-light">
                  Has not been assigned any courses(s) yet.
                </div>
              </div>
            </div>
            <div>
              <div
                class="row my-4"
                *ngFor="
                  let courseItem of courses
                    | paginate
                      : {
                          id: 'listing_pagination',
                          itemsPerPage: CoursePaginationInfo.size,
                          currentPage: CoursePaginationInfo.number,
                          totalItems: CoursePaginationInfo.totalElements
                        }
                "
              >
                <div class="col-lg-4 col-sm-12">
                  <div class="p-r">
                    <img
                      src="{{ courseItem.course.imageUrl }}"
                      alt=""
                      class="border-radius w-100 courseImg"
                    />
                    <span
                      class="badge"
                      [ngClass]="
                        courseItem.progress == 100
                          ? 'green-badge'
                          : 'yellow-badge'
                      "
                      >{{
                        courseItem?.progress == 100 ? 'Completed' : 'Ongoing'
                      }}</span
                    >
                  </div>
                </div>

                <div class="col-lg-6 col-sm-12 my-auto">
                  <p class="font-bold">
                    {{ courseItem.course.title }}
                  </p>
                  <div class="text-grey font12 my-0">
                    TYPE: <span> {{ courseItem.assignedCourseType }}</span>
                  </div>
                  <div
                    class="mt-4 d-flex justify-content-between record py-2 px-3"
                  >
                    <div>
                      <i class="fa fa-calendar"></i>
                      <span class="ml-2"> {{ courseItem.dueDate | date }}</span>
                    </div>

                    <div>
                      <span class="mr-1">
                        {{
                          courseItem.course.progress | number : '1.0-0'
                        }}</span
                      >
                      <i class="fa fa-percent"></i>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-sm-12 my-auto">
                  <button
                    class="btn btn-secondary btn-sm my-5"
                    (click)="confirmation(courseItem)"
                  >
                    Unassign
                  </button>
                </div>
              </div>
            </div>
            <div
              class="d-flex justify-content-center my-5 list-nav"
              *ngIf="courses.length > 0"
            >
              <div class="d-flex align-items-center sm-flex-column">
                <pagination-controls
                  id="listing_pagination"
                  (pageChange)="navigateCoursePage($event)"
                ></pagination-controls>
              </div>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade"
          id="pills-LearningPath"
          role="tabpanel"
          aria-labelledby="pills-LearningPath-tab"
        >
          <div>
            <div
              *ngIf="learningPath.length == 0"
              class="text-center emptyLearning py-5 mt-5"
            >
              <div class="font20 d-flex align-items-center m-auto">
                <img src="assets/icons/info.png" alt="" />
                <div class="ml-3 font-light">
                  Has has not been assigned any learning path(s) yet.
                </div>
              </div>
            </div>
            <div class="row my-4">
              <div
                class="col-lg-4 col-sm-12 my-3"
                *ngFor="
                  let learningItem of learningPath
                    | paginate
                      : {
                          id: 'listing_pagination',
                          itemsPerPage: learningPathPaginationInfo.size,
                          currentPage: learningPathPaginationInfo.number,
                          totalItems: learningPathPaginationInfo.totalElements
                        }
                "
              >
                <div class="p-r">
                  <img src="assets/images/course-bg.png" alt="" class="w-100" />
                  <span
                    class="badge"
                    [ngClass]="
                      learningItem.learningPath.progress == 100
                        ? 'green-badge'
                        : 'yellow-badge'
                    "
                    >{{
                      learningItem?.learningPath?.progress == 100
                        ? 'Completed'
                        : 'Ongoing'
                    }}</span
                  >
                </div>
                <div class="font-bold font16 my-2">
                  {{ learningItem.learningPath.name }}
                </div>
                <div class="text-grey font12 my-2">
                  {{ learningItem.learningPath.description }}
                </div>
                <div
                  class="mt-4 d-flex justify-content-between record py-2 px-3"
                >
                  <div>
                    <i class="fa fa-calendar"></i>
                    <span class="ml-3 font14">{{
                      learningItem.learningPath.dueDate | date
                    }}</span>
                  </div>
                  <div>
                    <span class="mr-1">
                      {{ learningItem.progress | number : '1.0-0' }}</span
                    >
                    <i class="fa fa-percent"></i>
                  </div>
                  <div>
                    <i class="fa fa-book"></i>
                    <span class="ml-3 font14">
                      {{ learningItem.learningPath.courses.length }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex justify-content-center my-5 list-nav"
              *ngIf="learningPath.length > 0"
            >
              <div class="d-flex align-items-center sm-flex-column">
                <pagination-controls
                  id="listing_pagination"
                  (pageChange)="navigateLearningPage($event)"
                ></pagination-controls>
              </div>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade"
          id="pills-ResultsCertificates"
          role="tabpanel"
          aria-labelledby="pills-ResultsCertificates-tab"
        >
          <div class="px-4 my-3">
            <div>
              <div
                *ngFor="
                  let courseItem of enrolledCourses
                    | paginate
                      : {
                          id: 'listing_pagination',
                          itemsPerPage: enrolledCoursePagination.size,
                          currentPage: enrolledCoursePagination.number,
                          totalItems: enrolledCoursePagination.totalElements
                        }
                "
              >
                <div class="row my-3 align-items-center">
                  <div class="col-lg-2 col-sm-12">
                    <img
                      src="{{
                        courseItem.imageUrl
                          ? courseItem.imageUrl
                          : 'assets/images/logo1.svg'
                      }}"
                      alt=""
                      class="w-100"
                      width="200"
                      height="200"
                      *ngIf="courseItem.isCompleted == true"
                    />
                    <img
                      src="{{
                        courseItem.imageUrl
                          ? courseItem.imageUrl
                          : 'assets/images/logo2.svg'
                      }}"
                      alt=""
                      class="w-100"
                      width="200"
                      height="200"
                      *ngIf="!courseItem.isCompleted == true"
                    />
                  </div>
                  <div class="col-lg-9 col-sm-12">
                    <div class="row align-items-center">
                      <div class="col-lg-6 col-sm-12">
                        <p class="mb-1 font-bold">
                          {{ courseItem.course.title }}
                        </p>
                        <p class="mb-1 font12 text-grey">Microsoft</p>
                        <p class="mb-1 font12">
                          Issued {{ courseItem.course.createdAt | date }}
                          <span
                            *ngIf="courseItem.isCompleted == true"
                            class="ml-3 badge bg-green"
                            >Certificate</span
                          >
                          <span
                            *ngIf="!courseItem.isCompleted == true"
                            class="ml-3 badge bg-blue"
                            >Result</span
                          >
                        </p>
                      </div>
                      <div class="col-lg-6 col-sm-12">
                        <div
                          class="d-flex justify-content-between record py-2 px-3"
                          *ngIf="courseItem.isCompleted == true"
                        >
                          <div
                            data-toggle="modal"
                            [attr.data-target]="
                              '#viewCertModal' + courseItem.course.id
                            "
                            class="font14 click"
                            *ngIf="courseItem?.course.hasCertificate"
                          >
                            <i class="fa fa-eye"></i>
                            <span class="ml-3">View</span>
                          </div>
                          <div
                            class="text-green font14"
                            *ngIf="!courseItem?.course.hasCertificate"
                          >
                            No Certificate
                          </div>
                          <div>
                            <a
                              href="{{ courseItem.course.certificateFileUrl }}"
                              download="certificate"
                            >
                              <i class="fa fa-download text-dark"></i>
                              <span class="ml-3 text-dark">Download</span>
                            </a>
                          </div>

                          <!--View Certificate Modal -->
                          <div
                            class="modal fade"
                            [id]="'viewCertModal' + courseItem?.course.id"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="viewCertModalLabel"
                            aria-hidden="true"
                          >
                            <div class="modal-dialog modal-lg" role="document">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h3 class="modal-title" id="viewModalLabel">
                                    Certificate
                                  </h3>
                                  <button
                                    type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body p-3">
                                  <div class="hidden">
                                    <object
                                      [data]="
                                        sanitizeUrl(
                                          courseItem.course?.certificateFileUrl
                                        )
                                      "
                                      type="application/pdf"
                                      width="100%"
                                      height="400px"
                                    ></object>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-between record py-2 px-3"
                          *ngIf="!courseItem.isCompleted == true"
                        >
                          <div
                            class="font14 click"
                            data-toggle="modal"
                            data-target="#viewResultModal"
                            *ngIf="!courseItem.isCompleted == true"
                          >
                            <i class="fa fa-eye"></i>
                            <span class="ml-3">View</span>
                          </div>
                          <!-- <div
                                  class=" text-green font14 "
                                  *ngIf="!courseItem.isCompleted == true"
                              >
                                  No Result
                              
                              </div> -->
                          <div class="click" (click)="downloadResult()">
                            <i class="fa fa-download text-dark"></i>
                            <span class="ml-3 text-dark">Download</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <hr />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center my-5 list-nav">
                <div class="d-flex align-items-center sm-flex-column">
                  <pagination-controls
                    id="listing_pagination"
                    (pageChange)="navigateEnrolledCoursePage($event)"
                  ></pagination-controls>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- deactivate Modal -->
<div
  class="modal fade"
  id="deactivateModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="deactivateModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deactivateModalLabel">
          {{ active ? 'Deactivate' : 'Activate' }} Staff Profile
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-4">
        <div class="hidden">
          <div class="my-5 bg-grey row p-4">
            <div class="col-lg-5 col-sm-12">
              <div class="profile m-auto">
                <img
                  src="{{
                    staff?.user?.avatarUrl
                      ? staff?.user?.avatarUrl
                      : 'assets/images/avatar.jpg'
                  }}"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg-7 col-sm-12">
              <p class="font28 font-bold mt-3">
                {{ staff?.user?.fullName }}
              </p>
              <p class="font14 font-bold">{{ staff?.division?.name }}</p>
              <p class="font14 font-bold mb-0">
                {{ staff?.department?.name }}
              </p>
            </div>
          </div>
          <p class="font16 px-3">
            {{
              active
                ? 'Are you sure you want to deactivate this profile? Please note that this action is not permanent and you can reactivate this staff profile not more than 5 years after deactivation date.'
                : 'Are you sure you want to activate this profile?'
            }}
          </p>
        </div>
      </div>
      <div class="modal-footer mt-3 py-3 d-flex justify-content-between">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-dismiss="modal"
        >
          Cancel
        </button>
        <button
          type="button"
          data-dismiss="modal"
          class="btn btn-secondary"
          (click)="activateDeactivateProfile()"
        >
          {{ active ? 'Deactivate' : 'Activate' }} Profile
        </button>
      </div>
    </div>
  </div>
</div>

<!--edit Modal -->
<div
  class="modal fade"
  id="editModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="editModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font18" id="editModalLabel">
          Edit Staff Detail
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form action="" [formGroup]="profileEditForm">
        <div class="modal-body px-5">
          <div class="row pt-5">
            <div class="col-lg-3 col-sm-12 sm-text-center">
              <div class="profile m-auto">
                <img
                  src="{{
                    staff?.user?.avatarUrl
                      ? staff?.user?.avatarUrl
                      : 'assets/images/avatar.jpg'
                  }}"
                  alt=""
                  style="height: 155px"
                />
                <div class="file-picker bg-green">
                  <label for="file" class="text-white mb-0 click"
                    ><i class="fa fa-plus"></i
                  ></label>
                  <input
                    type="file"
                    id="file"
                    (change)="getFile($event.target.files, staff?.user?.id)"
                    class="inputfile"
                    [ngClass]="{
                      'is-invalid': requiredFileType && file
                    }"
                  />
                </div>
                <div class="text-red m-0 p-0" *ngIf="requiredFileType && file">
                  Only *pdf, *jpg and *jpeg are allowed
                </div>
              </div>
            </div>
            <div class="col-lg-9 col-sm-12">
              <div>
                <div class="row">
                  <div class="col-12">
                    <p class="m-2 text-grey font12">Full Name</p>
                    <input
                      type="text"
                      class="common-input mb-3 bg-white text-grey w-100"
                      placeholder="  {{ staff?.user.fullName }}"
                      formControlName="fullName"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-sm-12">
                    <p class="m-2 text-grey font12">Role</p>

                    <select
                      type="text"
                      class="staff-input text-greyed bg-white w-100"
                      formControlName="designationId"
                    >
                      <option
                        value="{{ designation?.id }}"
                        *ngFor="let designation of designations"
                      >
                        {{ designation?.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-sm-12">
                    <p class="m-2 text-grey font12">Employment Number</p>
                    <input
                      type="text"
                      class="common-input mb-3 text-grey bg-white w-100"
                      formControlName="employmentNumber"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="m-2 text-grey font12">Email</p>
                    <input
                      type="text"
                      class="common-input text-grey mb-3 bg-white w-100"
                      placeholder=" {{ staff?.user.username }}"
                      formControlName="username"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-sm-12">
                    <p class="m-2 text-grey font12">Phone Number</p>
                    <input
                      type="text"
                      class="common-input text-grey mb-3 bg-white w-100"
                      formControlName="phoneNumber"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12">
                    <p class="m-2 text-grey font12">Department</p>
                    <select
                      type="text"
                      class="staff-input mb-3 bg-white w-100"
                      formControlName="departmentId"
                      (change)="getDivisions($event.target.value)"
                    >
                      <option value="" selected class="text-greyed">
                        Department
                      </option>
                      <option
                        value="{{ department.id }}"
                        *ngFor="let department of departments"
                      >
                        {{ department.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-sm-12">
                    <p class="m-2 text-grey font12">Division</p>
                    <select
                      type="text"
                      class="staff-input mb-3 bg-white w-100"
                      formControlName="divisionId"
                      (change)="getUnits($event.target.value)"
                    >
                      <option
                        value="{{ division.id }}"
                        *ngFor="let division of divisions"
                      >
                        {{ division.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-sm-12">
                    <p class="m-2 text-grey font12">Unit</p>
                    <select
                      type="text"
                      class="staff-input mb-3 bg-white w-100"
                      formControlName="unitId"
                    >
                      <option
                        value=""
                        class="text-greyed"
                        *ngIf="units.length == 0"
                      >
                        {{ staff?.unit?.name }}
                      </option>
                      <option value="{{ unit.id }}" *ngFor="let unit of units">
                        {{ unit.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-sm-12">
                    <p class="m-2 text-grey font12">Admin</p>
                    <select
                      type="text"
                      class="staff-input mb-3 bg-white w-100"
                      formControlName="isAdmin"
                    >
                      <option [value]="false">No</option>
                      <option [value]="true">Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="my-5">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  (click)="updateProfile()"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="footer-wrapper mt-auto">
  <hr />
  <iq-central-front-end-footer></iq-central-front-end-footer>
</div>
<!-- sendMessage Modal -->
<div
  class="modal fade"
  id="sendMessageModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="sendMessageModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="sendMessageModalLabel">
          Send Message to {{ staff?.user?.fullName }}
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-4">
        <div class="hidden">
          <form action="" [formGroup]="messageForm">
            <div class="row align-items-center">
              <input
                type="text"
                placeholder="Message Subject"
                formControlName="subject"
              />
            </div>
            <hr />
            <div>
              <textarea
                class="form-control"
                placeholder=" Enter message here "
                formControlName="content"
                [ngClass]="{
                  'is-invalid':
                    messageForm.get('content').errors &&
                    messageForm.get('content').touched
                }"
              ></textarea>
            </div>
          </form>
        </div>
      </div>
      <div class="my-4 text-center">
        <button
          type="button"
          (click)="sendMessage()"
          class="btn btn-secondary"
          data-dismiss="modal"
          [disabled]="messageForm.invalid"
        >
          Send Message
        </button>
      </div>
    </div>
  </div>
</div>

<!--View Result Modal -->
<div
  class="modal fade"
  id="viewResultModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="viewResultModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="viewModalLabel">Result</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="hidden" id="content">
          <h1>Hello World</h1>
          <img src="assets/images/certificate.png" alt="" class="w-100" />
        </div>
      </div>
    </div>
  </div>
</div>
